import { ReactNode } from "react";
import Input from "../Input";

interface InputProps {
  [key: string]: any;
  children?: ReactNode;
  CustomComponent?: JSX.Element;
}

interface RowInputsProps {
  inputs: InputProps[];
  colsCount?: number;
  className?: string;
  gapCount?: number;
  isLoading?: boolean;
}

const Renderer = ({ inputs }: { inputs: RowInputsProps["inputs"] }) => {
  return (
    <>
      {inputs.length
        ? inputs.map(
            (input) =>
              input.CustomComponent || (
                <div className="w-full" key={input.name}>
                  <Input key={input.name} {...input} />
                </div>
              )
          )
        : null}
    </>
  );
};

const RowInputs = (props: RowInputsProps) => {
  const { colsCount, gapCount, className } = props;
  return colsCount ? (
    <div
      className={`grid grid-cols-${colsCount} ${
        !!gapCount && "gap-" + gapCount
      } mb-5 ${className}`}
    >
      <Renderer inputs={props.inputs} />
    </div>
  ) : (
    <Renderer inputs={props.inputs} />
  );
};

export default RowInputs;
